import { B as h, j as a, T } from "./Spinner-dTAYYnIx.js";
import { styled as r, css as i } from "styled-components";
import { T as B } from "./typography.styled-aDVGHct9.js";
import { z as W, f as u, e as F, d as M, p as z, P as E, m as P } from "./index-QRkynDgW.js";
import { j, c as O, a as c, B as l, s as q, T as A } from "./style-8UHgYe1v.js";
import { useCallback as I, useState as k } from "react";
import L from "react-dom";
import R from "focus-trap-react";
import { u as D } from "./useTransitionState-9D4Z4_FK.js";
import { u as K, a as Q } from "./useElementRefById-afvP7SGi.js";
import { u as v } from "./useAddBodyClass-J7-kOyEU.js";
import { S as U } from "./Section-cF107_Su.js";
import { C as V } from "./icon-close-SnhI1pSy.js";
import { P as G } from "./PreventBodyOverflow-4Tam5bLu.js";
import { t as H } from "./index-M5QJYDAG.js";
import { S as J } from "./icon-share-PuinzEz7.js";
const N = "485px", X = "552px", Y = r.div`
  position: fixed;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 1fr;
  z-index: ${W.modal};
  width: 100vw;
  height: 100%;
  top: 0;
  left: 0;
`, Z = r.div`
  ${j("opacity")}
  opacity: ${({ $isVisible: t }) => t ? 1 : 0};
  background: ${O.greyAlpha80};
  grid-row-start: 1;
  grid-column-start: 1;
`, _ = r.div.attrs({ $justifyContent: "center", $alignItems: "center" })`
  place-self: center center;
  ${u}
  ${j("transform, opacity")}
  grid-row-start: 1;
  grid-column-start: 1;
  transform: ${({ $isOpen: t }) => t ? "scale(1)" : "scale(0.7)"};
  opacity: ${({ $isOpen: t }) => t ? 1 : 0};
  width: 100%;

  ${c(
  l.md,
  i`
      max-width: ${N};
    `
)}
  ${c(
  l.xl,
  i`
      max-width: ${X};
    `
)}
`, aa = r(U)`
  margin: 0 ${F.spacer3};
  border-radius: ${M.md};
  padding: 0;
  max-height: 90vh;
  flex-basis: 100%;
  overflow: hidden auto;
  ${c(
  l.md,
  i`
      margin: 0;
    `
)}
`, ta = r.div.attrs({
  $px: { xs: "spacer4", lg: "spacer6" },
  $pt: { xs: "spacer4", lg: "spacer5" },
  $pb: { xs: "spacer3" },
  $justifyContent: "flex-end"
})`
  ${u}
  ${z}
`, sa = r(h)`
  position: relative;

  &::after {
    ${q(44)}
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    content: '';
  }
`, C = ({
  modalRootId: t,
  children: d,
  ariaLabel: p,
  theme: o = "light",
  isOpen: s = !1,
  onClose: e,
  closeButtonAriaLabel: g,
  noHorizontalPad: m
}) => {
  const f = K(t), [y, x, n] = D(s, ["opacity"]);
  if (Q(
    I(
      (b) => {
        b.key === "Escape" && s && e();
      },
      [e, s]
    )
  ), v(s, "modal-open"), !t || !f || !y && !x)
    return null;
  const $ = "modal-section";
  return L.createPortal(
    /* @__PURE__ */ a.jsxs(T, { theme: o, children: [
      /* @__PURE__ */ a.jsx(G, { prevent: s }),
      /* @__PURE__ */ a.jsx(
        R,
        {
          active: !0,
          focusTrapOptions: {
            fallbackFocus: `#${$}`
          },
          children: /* @__PURE__ */ a.jsxs(Y, { children: [
            /* @__PURE__ */ a.jsx(
              Z,
              {
                onClick: e,
                onTransitionEnd: n,
                $isVisible: x,
                "data-qa": "modal-backdrop"
              }
            ),
            /* @__PURE__ */ a.jsx(_, { $isOpen: x, "data-qa": "modal-content-wrapper", children: /* @__PURE__ */ a.jsxs(aa, { role: "dialog", "aria-label": p, id: $, children: [
              /* @__PURE__ */ a.jsx(ta, { children: /* @__PURE__ */ a.jsx(
                sa,
                {
                  variant: "no-style",
                  icon: { icon: V, size: 20 },
                  "aria-label": g,
                  onClick: e,
                  dataQa: "modal-close-button"
                }
              ) }),
              /* @__PURE__ */ a.jsx(
                E,
                {
                  $px: { xs: m ? "spacer0" : "spacer4", lg: m ? "spacer0" : "spacer6" },
                  $pb: { xs: "spacer5" },
                  "data-qa": "modal-body",
                  children: d
                }
              )
            ] }) })
          ] })
        }
      )
    ] }),
    f
  );
}, ka = ({
  buttonLabel: t,
  children: d,
  isInitiallyOpen: p = !1,
  modalProps: o
}) => {
  const [s, e] = k(p);
  return /* @__PURE__ */ a.jsxs("div", { children: [
    /* @__PURE__ */ a.jsx(h, { onClick: () => e(!0), children: t }),
    /* @__PURE__ */ a.jsx(C, { ...o, isOpen: s, onClose: () => e(!1), children: d })
  ] });
}, ea = r(B).attrs({ $mb: "spacer6" })`
  ${P};
`, ra = r(h).attrs({ $mb: "spacer5", $justifyContent: "center" })`
  ${u};

  width: 33%;

  > span {
    display: none;
    ${c(
  l.md,
  i`
        display: block;
      `
)}
  }

  ${c(
  l.md,
  i`
      width: 50%;
    `
)}

  ${c(
  l.xl,
  i`
      width: 33%;
    `
)}
`, oa = r.div.attrs({
  $justifyContent: { xs: "center", md: "flex-start", lg: "center" },
  $flexWrap: "wrap"
})`
  ${u};
`, va = ({
  modalRootId: t,
  buttonText: d,
  modalTitle: p,
  ctas: o,
  buttonAriaLabel: s = "Share",
  closeButtonAriaLabel: e,
  ariaLabel: g
}) => {
  const [m, f] = k(!1), y = () => {
    f(!1);
  }, x = (n) => n && H(n);
  return v(m, "modal-open"), /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(h, { icon: { icon: J }, variant: "icon", onClick: () => f(!0), "aria-label": s, children: d }),
    /* @__PURE__ */ a.jsxs(
      C,
      {
        isOpen: m,
        onClose: y,
        modalRootId: t,
        closeButtonAriaLabel: e,
        ariaLabel: g,
        children: [
          /* @__PURE__ */ a.jsx(ea, { $variant: A.headingSSerif, as: "h2", $textAlign: "center", children: p }),
          o && o.length > 0 && /* @__PURE__ */ a.jsx(oa, { children: o.map(({ icon: n, text: $, href: b, ariaLabel: w, analytics: S }) => /* @__PURE__ */ a.jsx(
            ra,
            {
              onClick: () => x(S),
              icon: { icon: n, size: "sm" },
              href: b,
              variant: "icon",
              "aria-label": w,
              children: $
            },
            $
          )) })
        ]
      }
    )
  ] });
};
export {
  C as M,
  va as S,
  ka as a
};
